// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"296":"ea88be26","5507":"react-syntax-highlighter/refractor-import"}[chunkId] || chunkId) + "." + {"296":"1a112e62a60bad04","5507":"bac55981b7a82462","7441":"4f3bb6c4976a513a","9260":"8b664e9bc0e705da"}[chunkId] + ".js";
};